<div class="grid-filter-sections">
    <div [ngStyle]="{ '--header-height-desktop.px': HEADER_MAIN_DESKTOP_HEIGHT }" class="grid-filter-section menu">
        <div>
            <div class="results" [class.has-results]="filterGroups().length">
                <h-grid-filter-section-header></h-grid-filter-section-header>
            </div>
            @if (filterGroups().length) {
            <h-grid-filter-section></h-grid-filter-section>
            }
        </div>
    </div>

    <div class="grid-filter-section tags">
        <div> <h-grid-filter-tags></h-grid-filter-tags> </div>
    </div>
</div>
